import monitoringQuestionCategory from "@/api/credit-operation/monitoring-question-category";

import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    surveyors:[]
};

export const getters = {};

export const mutations = {
    ...baseMutations,
        SET_SURVEYOR(state, data) {
        state.surveyors = data;
    },
};

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        );
        return monitoringQuestionCategory.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    async getSurveyor(context, attributes = {}) {
        let response = await monitoringQuestionCategory.surveyor({ params: attributes });
        context.commit("SET_SURVEYOR", response.data);
    },
    changeIsActive(context, { id, data }) {
        return monitoringQuestionCategory.changeIsActive(id, data);
    },
    store(context, data) {
        return monitoringQuestionCategory.store(data);
    },
    update(context, { id, data }) {
        return monitoringQuestionCategory.update(id, data);
    },
    destroy(context, id) {
        return monitoringQuestionCategory.destroy(id);
    },
};
